import { useEffect } from "react";

export function fixDatePickerLocation(className) {
  const picker = document.querySelector(`.${className}`);
  const pickerpicker = document.querySelector(`.${className}_picker`);
  if (!picker || !pickerpicker) return;

  const rect = picker.getBoundingClientRect();

  const pxOffScreen =
    rect.left +
    pickerpicker.getBoundingClientRect().width -
    document.documentElement.clientWidth;
  pickerpicker.style.left =
    (pxOffScreen > 0 ? rect.left - pxOffScreen - 10 : rect.left) + "px";
  pickerpicker.style.top =
    rect.top +
    rect.height +
    (window.scrollY || document.documentElement.scrollTop) +
    "px";
  pickerpicker.style.opacity = 1;
}

export default function useFixPosition(fixPosition, className) {
  useEffect(() => {
    if (!fixPosition) return;
    const handler = fixDatePickerLocation.bind(null, className);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  });
}
